// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"042bb37f","453":"d855a71b","732":"9a305367"}[chunkId] + ".chunk.js";
};